/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.providerSubscription', [])
    .factory('providerSubscriptionService', ProviderSubscriptionService)
    .name;

/*@ngInject*/
function ProviderSubscriptionService($http, $q) {

    var service = {
        deleteProviderSubscription: deleteProviderSubscription,
        getProviderSubscription: getProviderSubscription,
        getProviderSubscriptions: getProviderSubscriptions,
        saveProviderSubscription: saveProviderSubscription,
    }

    return service;

    function getProviderSubscriptions () {
        var deferred = $q.defer();
        $http.get('/api/providerSubscriptions', null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getProviderSubscription (providerSubscriptionId) {
        var deferred = $q.defer();
        var url = '/api/providerSubscription/' + providerSubscriptionId;
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveProviderSubscription (providerSubscription) {
        var deferred = $q.defer();
        var url = '/api/providerSubscription';
        $http.post(url, providerSubscription).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function deleteProviderSubscription (providerSubscriptionId) {
        var deferred = $q.defer();
        var url = '/api/providerSubscription/' + providerSubscriptionId;
        $http.delete(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

}



// WEBPACK FOOTER //
// ./src/app/api/provider-subscription.service.js